import { addZero } from "./addZero";

export function nDaysFromNow(n) {
    const d = new Date();
    d.setDate(d.getDate() + n);
	const year = d.getFullYear();
	const month = addZero(d.getMonth() + 1);
	let date = addZero(d.getDate());

	date = `${year}${month}${date}`;

	return date;
}
